module.exports = __webpack_public_path__ + "static/media/mohit.baff6a21.gif";